// extracted by mini-css-extract-plugin
export default {"Popup":"Popup_Popup__qAcB7"};